<template>
  <div class="container">
    <head-nav-bar :title="title" :fixed="true" />
    <div class="doctor-info mt-header-nav">
      <div class="info">
        <doctor-card
          :data="info"
          :imgTag="false"
          :enabledDisplayDutyTitle="enabledDisplayDutyTitle"
        />
      </div>
      <div class="newstext" v-html="info.desc"></div>
    </div>
  </div>
</template>

<script>
import DoctorCard from "@/components/DoctorCard";

export default {
  components: {
    DoctorCard,
  },
  data() {
    return {
      info: {},
      enabledDisplayDutyTitle: false,
    };
  },
  computed: {
    title() {
      return this.info && this.info.name
        ? this.info.name + "医生介绍"
        : "医生介绍";
    },
  },
  created() {
    this.params = this.$route.query;
    this.getInfo();
    this.$post("GetWxSystemParameterInfo", {}).then(res => {
      this.enabledDisplayDutyTitle = res.data.enabledDisplayDutyTitle;
    });
  },
  methods: {
    getInfo() {
      this.$post("Doctor_Info", this.params).then(res => {
        this.info = res.data;
      });
    },
  },
};
</script>
